module.exports = __webpack_public_path__ + "static/media/inmujeres_gray.4cbf024e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inmujeres_gray.svg
// module id = 457
// module chunks = 0